import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { NotificationsService } from 'src/app/core/services/http/notifications/notifications.service';
// import { environment } from 'src/environments/environment';

import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss']
})
export class NotificationsListComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  notificationTypesList: any[] = [];
  isNotificationTypesLoaded: boolean = false;
  notificationList: any[] = [];
  filterForm: FormGroup;
  isNotificationLoaded: boolean = false;
  searchVal: String = '';
  displayList: boolean = true;
  isDataLoaded: boolean = true;
  notificationDataSource: MatTableDataSource<any>;
  isDateTypeSelected: boolean = true;
  minDate: Date = new Date();
  currentDate: Date = new Date();
  displayedColumns : string[];
  loadingOnSave: boolean = false;
  filteredNotificationCount: number = 0;
  pageIndex : number = 0;

  private subscriptionNotificationsListFilter!: Subscription;
  private destroy$: Subject<void>;
  constructor(
    private formBuilder : FormBuilder,
    private notificationService: NotificationsService
  ) {
    this.destroy$ = new Subject<void>();
    this.filterForm = this.createFormGroup();
    this.notificationDataSource = new MatTableDataSource<any>();
    this.displayedColumns = this.setDisplayedColumns();
  }

  createFormGroup(): FormGroup {
    return this.formBuilder.group({
      notificationTypeId: [null],
      startDate: [null],
      endDate: [null],
      searchString: [null]
    });
  }

  private fetchNotificationsList(): void {
    // this.subscriptionNotificationsListFilter?.unsubscribe();
    this.isNotificationLoaded = false;
    // let searchValues = {
    //   searchString: this.searchVal,
    //   searchColumns: 'firstName,lastName,uniqueGuestId',
    //   page: page,
    //   size: this.paginator.pageSize ?? environment.pageOptions.pageSize
    // }

    // if (this.filterForm.value.centerId && this.filterForm.value.centerId !== 'ALL_CENTER') {
      // searchValues = { ...searchValues, ...{ centerId: this.filterForm.value.centerId } };
    // }

    // this.subscriptionNotificationsListFilter = this.notificationService
    //   .fetchNotificationsList(searchValues)
    //   .pipe(
    //     tap(() => {
    //       this.isNotificationLoaded = true;
    //     }),
    //     takeUntil(this.destroy$)
    //   )
    //   .subscribe(res => {
    //     this.notificationList = res.data;
    //     this.filteredNotificationCount = res.total ?? 0;
    //   });

    // this.isNotificationLoaded = true;
    // this.loadingOnSave = false;
    // this.notificationDataSource.data = [
    //   {
    //     id: 1,
    //     title: 'Test',
    //     description: "Test Description",
    //     type: 'READ',
    //     createdAt: '2025-10-10'
    //   }
    // ]
  }

    onClickClearAll(): void {
    this.displayList = false;
    this.isDateTypeSelected = false;
    this.filterForm.reset();
    this.notificationDataSource.data = [];
    this.isDataLoaded = false;
    this.loadingOnSave = false;
  }

    onClickApplyFilter(): void {
    this.setFilterState();
  }

    setFilterState(): void {
    if (this.filterForm.invalid) {
      return;
    }
    this.loadingOnSave = true;
    this.displayList = true;
    // this.fetchNotificationsList();
  }

  setDisplayedColumns(): string[] {
    return ['sl_no', 'title', 'description', 'type', 'created_date','actions'];
  }

    onPageChange(e: PageEvent): void {
    this.pageIndex = e.pageIndex + 1;
    this.fetchNotificationsList();
  }

  onClickActions(): void {

  }
}
